import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  isLoading: false,
  isLoad: {},
  error: null,
  itemsPerPage: 10,
  currentPage: 1,
  totalCount: 0,

  filteredIsoMaterial: {
    isoMaterial: {},
    weldingGas: {},
    weldingMachine: {},
    weldWPQ: {},
    weldLog: {},
    ncrReport: {},
    projectReport: {},
  },
};

const fetchStarting = (state) => {
   state.isLoad = true;
   state.error = null;
};

const fetchFailures = (state, action) => {
  state.isLoad = false;
  state.error = action.payload;
};

const fetchListStart = fetchStarting;

const fetchListFailure = fetchFailures;

const inspectionFilterSlice = createSlice({
  name: "inspectionfilter",
  initialState,
  reducers: {
    // Get Iso Material Filter List
    fetchIsoMaterialFilterListStart: fetchListStart,
    fetchIsoMaterialFilterListSuccess: (state, action) => {
      const { type, data } = action.payload;
      state.filteredIsoMaterial.isoMaterial[type] = data;
      state.error = null;
    },
    fetchIsoMaterialFilterListFailure: fetchListFailure,

    // Get Weld Log Filter List
    fetchWeldLogFilterListStart: fetchListStart,
    fetchWeldLogFilterListSuccess: (state, action) => {
      const { type, data } = action.payload;
      state.filteredIsoMaterial.weldLog[type] = data;
      state.error = null;
    },
    fetchWeldLogFilterListFailure: fetchListFailure,

    // Get Iso Welding Machine Filter List
    fetchWeldingMachineFilterListStart: fetchListStart,
    fetchWeldingMachineFilterListSuccess: (state, action) => {
      const { type, data } = action.payload;
      state.filteredIsoMaterial.weldingMachine[type] = data;
      state.error = null;
    },
    fetchWeldingMachineFilterListFailure: fetchListFailure,

    // Get Wlding WPQ Filter List
    fetchWeldingWPQFilterListStart: fetchListStart,
    fetchWeldingWPQFilterListSuccess: (state, action) => {
      const { type, data } = action.payload;
      state.filteredIsoMaterial.weldWPQ[type] = data;
      state.error = null;
    },
    fetchWeldingWPQFilterListFailure: fetchListFailure,

    // Get Welding Gas Filter List
    fetchWeldingGasFilterListStart: fetchListStart,
    fetchWeldingGasFilterListSuccess: (state, action) => {
      const { type, data } = action.payload;
      state.filteredIsoMaterial.weldingGas[type] = data;
      state.error = null;
    },
    fetchWeldingGasFilterListFailure: fetchListFailure,

    // Get NCRReport Filter List
    fetchNcrReportFilterListStart: fetchListStart,
    fetchNcrReportFilterListSuccess: (state, action) => {
      const { type, data } = action.payload;
      state.filteredIsoMaterial.ncrReport[type] = data;
      state.error = null;
    },
    fetchNcrReportFilterListFailure: fetchListFailure,

    // Get Project Report Filter List
    fetchProjectReportFilterListStart: fetchListStart,
    fetchProjectReportFilterListSuccess: (state, action) => {
      const { type, data } = action.payload;
      state.filteredIsoMaterial.projectReport[type] = data;
      state.error = null;
    },
    fetchProjectReportFilterListFailure: fetchListFailure,

    // Pagination actions
    setCurrentPage(state, action) {
      state.currentPage = action.payload;
    },
    setItemsPerPage(state, action) {
      state.itemsPerPage = action.payload;
    },
  },
});

export const {
  fetchIsoMaterialFilterListStart,
  fetchIsoMaterialFilterListSuccess,
  fetchIsoMaterialFilterListFailure,
  fetchWeldLogFilterListStart,
  fetchWeldLogFilterListSuccess,
  fetchWeldLogFilterListFailure,
  fetchWeldingMachineFilterListStart,
  fetchWeldingMachineFilterListSuccess,
  fetchWeldingMachineFilterListFailure,
  fetchWeldingWPQFilterListStart,
  fetchWeldingWPQFilterListSuccess,
  fetchWeldingWPQFilterListFailure,
  fetchWeldingGasFilterListStart,
  fetchWeldingGasFilterListSuccess,
  fetchWeldingGasFilterListFailure,
  fetchNcrReportFilterListStart,
  fetchNcrReportFilterListSuccess,
  fetchNcrReportFilterListFailure,
  fetchProjectReportFilterListStart,
  fetchProjectReportFilterListSuccess,
  fetchProjectReportFilterListFailure,
} = inspectionFilterSlice.actions;

export default inspectionFilterSlice.reducer;
